<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
        ></app-wysiwyg>

        <app-filepicker
            label="Bild"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.image'"
            accept=".jpg,.png,.gif"
            :show-focus="true"
            :show-transparency="false"
            :show-scaling-mode="true"
        ></app-filepicker>

        <app-link
            label="Button 1"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link'"
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link2'"
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link3'"
        ></app-link>
    </div>
</template>

<script>
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R027'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-wysiwyg': Wysiwyg,
        'app-link': Link,
        'app-filepicker': Filepicker
    }
};
</script>
